<p-panel header="{{ 'PRODUCTO.LBL_PRODSEGUANAL' | translate }}" >
  <app-loading *ngIf="carInformacionInicial"></app-loading>
  <div *ngIf="!carInformacionInicial">
    <form [formGroup]="formulario" *ngIf="!editar" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
      <div class="grid align-items-center">
        <div class="col-12 md:col-4 lg:col-4 pt-0">
          <div class="div-form">
            <label>* {{'PRODUCTO.LBL_PRODSEGUANAL' | translate}}:</label>
            <p-dropdown disableTab  id="idSeguro" name="nomIdSeguro" [options]="lisSeguros"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idSeguro"
                        (onChange)="validarTipoVivienda()"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        filter="filter"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idSeguro.invalid">
              {{ 'PRODUCTO.LBL_PRODSEGUANAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-2 lg:col-2">
          <div class="div-form">
            <p-checkbox label="{{ 'SEGURO.LBL_APLICACONFIGURACIONADICIONAL' | translate}}" binary="true"
                        id="idAplicacionAdicional" (onChange)="cambioInformacionAdicional($event)"
                        name="nomAplicacionAdicional"
                        formControlName="indicadorAplicaConfiguracionAdicional"></p-checkbox>
          </div>
        </div>

        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <label>*{{ 'SEGURO.LBL_METODOPAGO' | translate }}</label>
            <p-dropdown disableTab  id="idTipoMetodoPago" name="nomTipoMetodoPago" [options]="listaTipoMetodoPago"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        formControlName="idTipoMetodoPago"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        filter="filter"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoMetodoPago.invalid">
              {{ 'SEGURO.LBL_METODOPAGO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>

        <div class="col-12 md:col-1 lg:col-1">
          <div class="div-form">
            <p-checkbox label="{{ 'PRODUCTO.LBL_OBLIGATORIO' | translate}}" binary="true"
                        id="idObligatorio"
                        name="nomObligatorio"
                        (onChange)="deshabilitarNoEliminable($event)"
                        formControlName="indicadorObligatorio"></p-checkbox>
          </div>
        </div>


        <div class="col-12 md:col-1 lg:col-1">
          <div class="div-form">
            <p-checkbox label="{{ 'SEGURO.LBL_NOELIMINABLE' | translate}}" binary="true"
                        [disabled]="f.indicadorObligatorio.value"
                        id="idNoEliminable"
                        name="nomNoEliminable"
                        formControlName="indicadorNoEliminable"></p-checkbox>
          </div>
        </div>


        <div class="col-12 md:col-3 lg:col-3">
          <div class="div-form">
            <p-checkbox label="{{ 'SEGURO.LBL_ENVIAR' | translate}}" binary="true"
                        id="indicadorEnviar"
                        name="nomEnviar"
                        formControlName="indicadorEnviar"></p-checkbox>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="f.indicadorAplicaConfiguracionAdicional.value">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>{{ 'SEGURO.LBL_TIPODIRECCION' | translate }}</label>
            <p-dropdown disableTab  id="idTipoDireccion" name="nomTipoDireccion" [options]="lisTipoDireccion"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idTipoDireccion"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        filter="filter"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoDireccion.invalid">
              {{ 'SEGURO.LBL_TIPODIRECCION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>{{ 'SEGURO.LBL_TIPOVIVIENDA' | translate }}</label>
            <p-dropdown disableTab  id="idClaseVivienda" name="nomClaseVivienda" [options]="selectClaseVivienda" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idClaseVivienda"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idClaseVivienda.invalid">
              {{ 'SEGURO.LBL_TIPOVIVIENDA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>{{ 'SEGURO.LBL_TIPOCONSTRUCCION' | translate }}</label>
            <p-multiSelect id="idTipoConstruccion" name="nomTipoConstruccion" [options]="lisTipoConstruccion" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idTipoConstruccion"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoConstruccion.invalid">
              {{ 'SEGURO.LBL_TIPOCONSTRUCCION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>{{ 'SEGURO.LBL_TIPOOCUPACION' | translate }}</label>
            <p-dropdown disableTab  id="idTipoOcupacion" name="nomTipoOcupacion" [options]="lisTipoOcupacion" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                         formControlName="idTipoOcupacion"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoOcupacion.invalid">
              {{ 'SEGURO.LBL_TIPOOCUPACION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando || !editar">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid ">
      <div class="col-12 md:col-6 lg:col-6 md:col-offset-6 lg:col-offset-6">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carTabla" #dt
                 [value]="lisProductoSeguro" selectionMode="single" dataKey="idProductoSeguro"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigoSeguro}}</td>
              <td>{{row.nombreSeguro}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorBeneficiariosSeguro" binary="true" disabled="true"></p-checkbox>
              </td>
              <td>{{row.nombreCuestionarioSeguro}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorAplicaConfiguracionAdicional" binary="true" disabled="true"></p-checkbox>
              </td>
              <td>{{row.tipoDireccion}}</td>
              <td>{{row.claseVivienda}}</td>
              <td>{{row.tipoConstruccion}}</td>
              <td>{{row.tipoOcupacion}}</td>
              <td>{{row.tipoMetodoPago}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorEnviar" binary="true" disabled="true"></p-checkbox>
              </td>

              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorObligatorio" binary="true" disabled="true"></p-checkbox>
              </td>

              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorNoEliminable" binary="true" disabled="true"></p-checkbox>
              </td>

              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>

              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" *ngIf="!editar" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_ELIMINAR' | translate}}"
                          pButton (click)="cambiarHabilitado(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

</p-panel>
<p-confirmDialog key="p-seguros-aceptar" #cd2>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_ACEPTAR' | translate }}" (click)="cd2.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-confirmDialog key="p-seguros" #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

